"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var exchange_clients_commons_1 = require("@mulesoft/exchange-clients-commons");
var debug_1 = __importDefault(require("debug"));
var log = (0, debug_1.default)('exchange:tier:service');
var TIME_UNITS = [
    {
        label: 'Year',
        value: 31536000000
    },
    {
        label: 'Month',
        value: 2592000000
    },
    {
        label: 'Week',
        value: 604800000
    },
    {
        label: 'Day',
        value: 86400000
    },
    {
        label: 'Hour',
        value: 3600000
    },
    {
        label: 'Minute',
        value: 60000
    },
    {
        label: 'Second',
        value: 1000
    },
    {
        label: 'Millisecond',
        value: 1
    }
];
function normalizeSLALimit(slaLimit) {
    var slaTimePeriodInMilliseconds = slaLimit.timePeriodInMilliseconds;
    var slaTimeUnit = TIME_UNITS.find(function (timeUnit) { return slaTimePeriodInMilliseconds % timeUnit.value === 0; });
    var slaTimePeriod = slaTimePeriodInMilliseconds / slaTimeUnit.value;
    return {
        timeUnit: slaTimeUnit.label,
        timePeriod: slaTimePeriod,
        maximumRequests: slaLimit.maximumRequests
    };
}
function mapSLAResponse(slaTier) {
    return __assign(__assign({}, slaTier), { normalizedLimits: slaTier.limits.map(normalizeSLALimit) });
}
function mapAPIGroupSLAResponse(slaTier) {
    return __assign(__assign({}, slaTier), { normalizedLimitsByAPI: slaTier.limitsByApi.map(function (limitsForAPI) { return (__assign(__assign({}, limitsForAPI), { limits: (limitsForAPI.limits || []).map(normalizeSLALimit) })); }) });
}
var TierService = /** @class */ (function (_super) {
    __extends(TierService, _super);
    function TierService() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.list = function (_a) { return __awaiter(_this, [_a], void 0, function (_b) {
            var url, response, json;
            var context = _b.context, groupId = _b.groupId, assetId = _b.assetId, versionGroup = _b.versionGroup, apiId = _b.apiId;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        url = this.getAPIUrl({
                            context: context,
                            pathname: "/api/v2/assets/".concat(groupId, "/").concat(assetId, "/versionGroups/").concat(encodeURIComponent(versionGroup), "/instances/").concat(apiId, "/tiers")
                        });
                        log('Listing tiers', {
                            groupId: groupId,
                            assetId: assetId,
                            versionGroup: versionGroup,
                            apiId: apiId
                        });
                        return [4 /*yield*/, this.fetch(url, { context: context })];
                    case 1:
                        response = _c.sent();
                        return [4 /*yield*/, response.json()];
                    case 2:
                        json = (_c.sent());
                        return [2 /*return*/, json.map(mapSLAResponse)];
                }
            });
        }); };
        _this.listForAPIGroup = function (_a) { return __awaiter(_this, [_a], void 0, function (_b) {
            var url, response, json;
            var context = _b.context, groupId = _b.groupId, assetId = _b.assetId, versionGroup = _b.versionGroup, environmentId = _b.environmentId, apiGroupInstanceId = _b.apiGroupInstanceId, domain = _b.domain;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        url = this.getAPIUrl({
                            context: context,
                            pathname: domain
                                ? "/api/v2/portals/".concat(domain, "/assets/").concat(groupId, "/").concat(assetId, "/versionGroups/").concat(encodeURIComponent(versionGroup), "/environments/").concat(environmentId, "/apiGroupInstances/").concat(apiGroupInstanceId, "/tiers")
                                : "/api/v2/assets/".concat(groupId, "/").concat(assetId, "/versionGroups/").concat(encodeURIComponent(versionGroup), "/environments/").concat(environmentId, "/apiGroupInstances/").concat(apiGroupInstanceId, "/tiers")
                        });
                        log('Listing tiers for API group', {
                            groupId: groupId,
                            assetId: assetId,
                            versionGroup: versionGroup,
                            environmentId: environmentId,
                            apiGroupInstanceId: apiGroupInstanceId,
                            domain: domain
                        });
                        return [4 /*yield*/, this.fetch(url, { context: context })];
                    case 1:
                        response = _c.sent();
                        return [4 /*yield*/, response.json()];
                    case 2:
                        json = _c.sent();
                        return [2 /*return*/, json.map(mapAPIGroupSLAResponse)];
                }
            });
        }); };
        return _this;
    }
    return TierService;
}(exchange_clients_commons_1.BaseService));
exports.default = TierService;
